import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { ToastContainer, toast } from "react-toastify";
import { SampleBase } from './sample-base';
import $ from 'jquery';
import Loader from 'react-loader-spinner';


class CreateNewProject extends SampleBase {

  

  constructor() {
    super(...arguments);
    this.dialogClose = () => {
      this.props.history.push('/projectmgmt');
  };
  
    this.state = {
      fields: {},
      errors: {},
      createdSuccessPopup: false,
     domains:[],
     domainData:{text: 'name', value: 'code'},
     loading : false,
     successResp: false,
    }
     
        }
  
   cancel = (e) => {
     
    if(localStorage.getItem("currentProjectId")== null || localStorage.getItem("currentProjectId")== undefined
    ||localStorage.getItem("currentProjectId")==''){
      this.props.history.push('/');
    }else{
      window.history.back();
    }
    
    
  }
  moveToPlansPage = (projectId) => {
    this.props.history.push({
      pathname: '/project-plan-settings',
      projectData: {
        projectId: projectId
      }
    });
  }
  
  handleChange = (e) => {
    let fields = this.state.fields;
    fields[e.target.name] = e.target.value;
    this.setState({
      fields
    });

  }
  validateName = (e) => {
    let fields = this.state.fields;
    let errors = {};
    if (!fields["projectname"]) {
      errors["projectname"] = "*Please Enter your project name";
    }
    this.setState({
      errors:errors
    });
   
}
validateDescription = (e) => {
  let fields = this.state.fields;
  let errors = {};
  if (!fields["description"]) {
    
    errors["description"] = "*Please Enter description"

  }
  this.setState({
    errors:errors
  });
  
}
validateDomain = (e) => {
  let fields = this.state.fields;
  let errors = {};
  if (document.getElementById('domain').ej2_instances[0].value == null) {
    errors["domain"]="Please select the domain"
  }
  this.setState({
    errors:errors
  });
  
}
  
  validateAllFields = (e) => {
    e.preventDefault();
    if (this.validateForm()) {

    }
  }
  NotifyFailToCreate(falseRes) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{falseRes}</b>, {
      position: "top-center",
      color: "red"

    });
  }
  NotifyCreateSuccessMsg(Projectkey) {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;{Projectkey}</b>, {
      position: "top-center"
    });
  }

  createNewProject = (e) => {
    let createProjectController = this;
    if (this.validateForm()) {
      createProjectController.setState({loading:true})
      setTimeout(() => {
     var selectedDomain = document.getElementById('domain').ej2_instances[0].value;
      var formData = {"userId": JSON.parse(localStorage.getItem("user_details"))["userId"],
      name: createProjectController.state.fields.projectname, 
      projectDescription: document.getElementById('project_description').value,
      domain:selectedDomain,
      clusterUrl:"https://dev.dhee.net.in",
      isDeployed:true,
      deployedTime:123,
      isBuild:false,
      isDeleted:false,
      isSuspended:false
    };
    var showPopup = this;
        $.ajax({
           url: "/api/project",
           async: false,
           method: 'POST',
           headers: { 'Authorization': "Bearer " + localStorage.getItem("access_token"),
           'Content-Type': 'application/json'},
           data:JSON.stringify(formData) ,
           processData: false,
           contentType: "application/json; charset=UTF-8",
           success: function (res) {
             if (res.success === true) {
              localStorage.setItem("currentProjectId",res.result.id);
              window.currentProjectId=res.result.id ;
              createProjectController.NotifyCreateSuccessMsg(formData.name + " created successfully");
              createProjectController.setState({loading:false})
            var projectTimer = setInterval(function () {
              clearTimeout(projectTimer);
              createProjectController.moveToPlansPage(localStorage.getItem("currentProjectId"));
            }, 2000);
              
               let fields = {};
               fields["projectname"] = "";
               fields["description"] = "";      
               fields["domain"] = ""
           } else {
               createProjectController.NotifyFailToCreate(res.result);
               createProjectController.setState({loading:false})
               
   
             }
           },
            error: function(xhr, status, error){
                 var errorMessage = xhr.status + ': ' + xhr.statusText
                 if(xhr.status==401){
                   window.location.href = "/platform/";

                 }
             }
         
         })
         }, 1000);
    }



  }



  validateForm() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    if (!fields["projectname"]) {
      formIsValid = false;
      errors["projectname"] = "Please Enter your project name"

    }
    if (!fields["description"]) {
      formIsValid = false;
      errors["description"] = "Please Enter description"

    }
    if (document.getElementById('domain').ej2_instances[0].value == null) {
      formIsValid = false;
      errors["domain"] = "Please select domain"

    }

    this.setState({
      errors: errors
    });
    return formIsValid;
  }

  getDomain() {
    var domainDropDownController = this;
     $.ajax({
       url: "/api/global-domains",
       async: false,
       method: 'GET',
       headers: { "Authorization": "Bearer " + localStorage.getItem("access_token")
      },
       success: function (res) {
         if (res.success === true) {
           var domains = res.result;
           domainDropDownController.setState({
            domains: domains,
            successResp: true,
          });
           
       }else{
       domainDropDownController.NotifyFailToCreate(res.result);
       }
     },
    error: function(xhr, status, error){
      var errorMessage = xhr.status + ': ' + xhr.statusText
      if(xhr.status==401){
        window.location.href = "/platform/";
       
      }
  }
     });
  }

  componentDidMount() {
    this.getDomain();
  }


  render() {
    const {loading} = this.state;

    return (
      <div className="wrapper WebContainer" id="createproject1id">
        <div className="loader" />
        <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={this.state.successResp ? false : true}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center', marginTop: window.innerHeight / 6 + "px" }}
                />
                <div style={{ display: this.state.successResp ? 'block' : 'none' }}>
        < ToastContainer className="Toast-at-center"/>   
        <div>
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/select2.min.css" />
          <link rel="stylesheet" href="assets/css/flaticon.css" />
          <link rel="stylesheet" href="assets/css/index.css" />
           <link rel="stylesheet" href="assets/css/modal-style.css" />
           <link rel="stylesheet" href="assets/css/drop-down-alignment.css" />
           <link href="assets/css/material.css" rel="stylesheet"/>
           <link href="assets/css/bootstrap.min.css" rel="stylesheet" />
           <link rel="stylesheet" href="assets/css/ReactToastify.css" />
          <script src="plugins/select2/select2.full.min.js"></script>
          <script src="plugins/select2/select2.min.js"></script>
          <div className="row col-md-12 p-0 m-0">
         
            <div className="col-md-5">
              <form className="form-horizontal">
                <div className="card-body p-0">
                  <div className="row">
                    <div className="col-lg-12 p-0">
                      <div className="card sign-in-right-tab">
                        <div className="card-body sign-in-page">
                          <div className="col-sm-12">
                            <div className="logoBox mb-5">
                              <img src="assets/images/dheeai.png" className="mb-2" />
                              {/* <h5 class="signinTitle">Sign in to Dheeyantra</h5> */}
                            </div>
                          </div>
                          <div className="col-9 p-0 mx-auto ">
                            <div className="form-group">
                            <h5 className="signinTitle" style={{color : '#0270c0'}}>Project Wizard</h5>
                            </div>
                            <div className="crplan mt-1">Create your project</div>
                            <br />
                            
                            <div>
    
                              <input className="input-group mb-3 form-control" type="text"  name="projectname" id='projectname' style={{fontFamily: "inherit"}} onChange={this.handleChange} onBlur={this.validateName} 
                                  placeholder="Project Name " />
                              <div style={{ color: "red" }} className="errorMsg">{this.state.errors.projectname}</div>

                            </div><br />
                            
                            <textarea placeholder="Description format" className="form-control" rows={3} maxLength={250} onChange={this.handleChange} onBlur={this.validateDescription} style={{fontFamily: "inherit"}} name="description" id="project_description" autoComplete="off" defaultValue={""} />

                            <div style={{ color: "red" }} className="errorMsg">{this.state.errors.description}</div>
                            <br />


                            <div id='default'>
                          <DropDownListComponent id="domain" dataSource={this.state.domains} ref={(dropdownlist) => { this.listObj = dropdownlist; }} fields={this.state.domainData} style={{fontFamily: "inherit",fontSize:"14px"}} onBlur={this.validateDomain}  placeholder="Select a domain" value={this.value} popupHeight="220px"/>
              
                            </div>
                            <div style={{ color: "red" }} className="errorMsg">{this.state.errors.domain}</div>
                              <br />
                              <div className='row' style={{margin : "0px 10px 0px -15px"}}>
                              <div className='col-sm-6'>
                              <button type="button" className="btn navyblue-btn" style={{marginRight:'6px',width:'100%',height:'40px',align:'left'}}  id="project"  
                              onClick={this.createNewProject} disabled={loading}>
                                {loading && <i className="fa fa-refresh fa-spin"></i>}
                                {loading &&<span>&nbsp;&nbsp;Creating Project</span>}
                                {!loading &&<span>&nbsp;&nbsp;Create Project</span>}</button>
                                </div>
                                <div className='col-sm-6'>
                              <button type="button" style={{ marginLeft:'10px',width:'100%',height:'40px',align:'right' }} className="btn navyblue-btn" onClick={this.cancel} disabled={loading}>Cancel</button>
                          </div>
                          </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="col-md-7 pay3-bg pr-5 pl-5" />
          </div>
        </div>
     
      </div>
      </div>

    );

  }

}

export default CreateNewProject;


// WEBPACK FOOTER //
// ./src/sales-desk/projects/CreateNewProject.js